import { render } from "./dropdown-arror.svg?vue&type=template&id=e14c62aa"
const script = {}
script.render = render

export default script